//测试环境
const admin_api = 'https://www.yktexam.cn/api';
const admin_urls = 'https://www.yktexam.cn/';
const WEB_URL = 'https://www.yktexam.cn/';
const IMG_URL = 'https://imgs.zzszjedu.cn/';
export default {
    // 时间格式化
    shortFormatDate(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear()
        // 月份从0开始，需要加1
        const month = this.padZero(date.getMonth() + 1)
        const day = this.padZero(date.getDate())
        const hours = this.padZero(date.getHours())
        const minutes = this.padZero(date.getMinutes())
        //const seconds = this.padZero(date.getSeconds())
        return `${year}-${month}-${day} ${hours}:${minutes}`
        //return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },
    // 数字补零
    padZero(num) {
        return num < 10 ? '0' + num : num;
    },
    admin_api,
    admin_urls,
    IMG_URL,
    WEB_URL,
}
